/**
 * AutoPay Status API
 * URL: https://developer.syf.com/api-reference/repayments-v1#operation/GetAutopayStatusV1
 */
export enum PaymentMedium {
  ECheck = 'E_CHECK',
  PinlessDebitCard = 'PINLESS_DEBIT_CARD',
  CreditCard = 'CREDIT_CARD'
}

export enum AutoPayPaymentOption {
  MinimumPaymentDue = 'MINIMUM_PAYMENT_DUE',
  StatementBalance = 'STATEMENT_BALANCE',
  UserEnteredAmount = 'USER_ENTERED_AMOUNT',
  NewMinimumMonthlyDue = 'NEW_MINIMUM_MONTHLY_DUE',
  InterestSaverAmount = 'INTEREST_SAVER_AMOUNT',
  CurrentCycleMinimumPaymentDue = 'CURRENT_CYCLE_MINIMUM_PAYMENT_DUE'
}

export enum CardNetwork {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  MaterCard = 'MASTERCARD',
  Visa = 'VISA'
}

export enum BankChannel {
  PayByPhone = 'PAYBYPHONE',
  Digital = 'DIGITAL'
}

export interface AutoPayEnrollmentDetails {
  paymentOption: AutoPayPaymentOption
  paymentAmount: string
  nextDueDate: string
  effectiveCurrentCycle: boolean
}

export interface PaymentMethodsDetails {
  bankAccountNumberLast4: string
  bankRoutingNumber: string
  type: string
  id?: string
  name: string
  nickname?: string
  bankChannel?: BankChannel
  status: string
}

export interface PaymentCardInfo {
  id?: string
  cardNumberLast4?: string
  ['cipher.expDate']?: string
  type?: CardNetwork
}
export interface AutoPayStatusResponse {
  enrollment: boolean
  paymentMedium?: PaymentMedium
  enrollmentDetails?: AutoPayEnrollmentDetails
  paymentMethod?: PaymentMethodsDetails
  paymentCardInfo?: PaymentCardInfo
}

export interface AutoPayStatusRequest {
  accountId: string
  accountIdType: string
  accessToken: string
}

/**
 * AutoPay Enroll API
 * URL: https://developer.syf.com/api-reference/repayments-v1#operation/UpdateAutopayV1
 */
const accountID = 'cipher.accountId'

export interface AutoPayEnrollPayload {
  [accountID]: string
  accountIdType: string
  enrollment: boolean
  paymentOption?: AutoPayPaymentOption
  paymentAmount?: string
  paymentMedium?: PaymentMedium
  paymentCardInfo?: {
    id?: string
    cardNumberLast4?: string
    'cipher.expDate'?: string
    type?: CardNetwork
  }
  paymentMethod?: {
    id?: string
    'cipher.bankAccountNumber'?: string
    'cipher.bankRoutingNumber'?: string
    type?: string
    name?: string
    nickname?: string
  }
}

export interface AutoPayEnrollRequest {
  accessToken: string
  requestBody: AutoPayEnrollPayload
}

/**
 * AutoPay Payments History API
 * URL: https://developer.syf.com/api-reference/repayments-v1#operation/GetAutopaymentsV1
 */

export interface AutoPayPayment {
  paymentId: string
  scheduledDate: string
  amount: string
}

export interface AutoPayHistoryResponse {
  payments: AutoPayPayment[]
}

export interface AutoPayHistoryRequest {
  accountId: string
  accountIdType: string
  accessToken: string
}
